import ServicesApi from './ServicesApi';

export default class PreferenceApi {
  static servicePrefix = 'preferenceservice/';

  static async retrieveAllPreferences() {
    const headers = await ServicesApi.getHeaders();

    var url = PreferenceApi.servicePrefix + 'retrieveall';

    const retrieveResponse = await fetch(
      url, {
      method: 'GET',
      headers: headers
    });

    var preferences = await retrieveResponse.json();
    preferences.forEach(preference => {
      preference.value = PreferenceApi.convertJSONToValue(preference.value);
    });
    
    return preferences;
  }

  static async retrievePreference(group, name) {
    const headers = await ServicesApi.getHeaders();

    var url = PreferenceApi.servicePrefix + 'retrieve?group=' +
      encodeURIComponent(group) + '&name=' + encodeURIComponent(name);

    const retrieveResponse = await fetch(
      url, {
      method: 'GET',
      headers: headers
    });

    var preference = await retrieveResponse.json();
    preference.value = PreferenceApi.convertJSONToValue(preference.value);
    return preference;
  }

  static async updatePreferences(preferences, onUpdateFinished) {
    const headers = await ServicesApi.getHeaders();

    var bodyData = [];
    preferences.forEach(preference => {
      bodyData.push({
        group: preference.group,
        name: preference.name,
        value: PreferenceApi.convertValueToJSON(preference.value)
      });
    });

    fetch(
      PreferenceApi.servicePrefix + 'update', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(bodyData)
    }).then(onUpdateFinished);
  }

  static async deletePreference(group, name, onUpdateFinished) {
    const headers = await ServicesApi.getHeaders();

    var url = PreferenceApi.servicePrefix + 'delete?group=' +
      encodeURIComponent(group) + '&name=' + encodeURIComponent(name);

    fetch(
      url, {
      method: 'DELETE',
      headers: headers,
    }).then(onUpdateFinished);
  }

  static async setDefaultPreferences(preferences, onUpdateFinished) {
    const headers = await ServicesApi.getHeaders();

    var bodyData = [];
    preferences.forEach(preference => {
      bodyData.push({
        group: preference.group,
        name: preference.name,
        value: PreferenceApi.convertValueToJSON(preference.value)
      });
    });

    fetch(
      PreferenceApi.servicePrefix + 'setdefaults', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(bodyData)
    }).then(onUpdateFinished);
  }

  static async deleteDefaultPreferences(group, names, onUpdateFinished) {
    const headers = await ServicesApi.getHeaders();

    var url = PreferenceApi.servicePrefix + 'deletedefaults?group=' +
      encodeURIComponent(group) + '&names=' + encodeURIComponent(names.join('+'));

    fetch(
      url, {
      method: 'DELETE',
      headers: headers,
    }).then(onUpdateFinished);
  }

  static async deletePreferencesForAllUsers(group, names, onUpdateFinished) {
    const headers = await ServicesApi.getHeaders();

    var url = PreferenceApi.servicePrefix + 'deleteforallusers?group=' +
      encodeURIComponent(group) + '&names=' + encodeURIComponent(names.join('+'));

    fetch(
      url, {
      method: 'DELETE',
      headers: headers,
    }).then(onUpdateFinished);
  }

  static convertValueToJSON(value) {
    return (value !== undefined && value !== null)
      ? JSON.stringify(value)
      : null;
  }

  static convertJSONToValue(value) {
    return (value !== undefined && value !== null)
      ? JSON.parse(value)
      : null;
  }
}